// src/hooks/useSessionHeartbeat.js
import { useEffect } from "react";
import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export default function useSessionHeartbeat({
  intervalMs = 30000, // enviar ping cada 30s
  idleMs = 60000, // considerar inactivo si no hay eventos en 60s
} = {}) {
  useEffect(() => {
    const token = localStorage.getItem("token");
    const sessionId = Number(localStorage.getItem("sessionId") || 0);
    if (!token || !sessionId) return;

    let lastActivity = Date.now();
    let sending = false;
    const events = ["mousemove", "keydown", "scroll", "click", "touchstart"];

    const mark = () => (lastActivity = Date.now());
    events.forEach((ev) =>
      window.addEventListener(ev, mark, { passive: true })
    );

    const onVis = () => {
      if (!document.hidden) {
        lastActivity = Date.now();
        void ping(true);
      }
    };
    document.addEventListener("visibilitychange", onVis);

    const ping = async (immediate = false) => {
      const now = Date.now();
      const idle = now - lastActivity > idleMs;
      if (idle && !immediate) return; // no sumar si está inactivo

      if (sending) return;
      sending = true;
      try {
        await axios.post(
          `${API_BASE_URL}/api/tiempos/session/ping`,
          { sessionId, at: new Date().toISOString() },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (e) {
        // silencioso
      } finally {
        sending = false;
      }
    };

    const timer = setInterval(() => ping(false), intervalMs);
    void ping(true); // primer ping inmediato

    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVis);
      events.forEach((ev) => window.removeEventListener(ev, mark));
    };
  }, []);
}
